import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import {
    AcceptContractRequest,
    ConsentDetails,
    ContractEndpoints,
    ContractState,
    GetContractApiResponse,
} from './contractTypes';
import { initialStateContract as initialState } from './contractStateDefaultValue';
import { ApiStatus } from '../../types';

const contractSlice = createSlice({
    name: 'contracts',
    initialState,
    reducers: {
        createContract(state) {
            state.createContractApiStatus = ApiStatus.Pending;
        },
        createContractFulfilled(state, action: PayloadAction<GetContractApiResponse>) {
            const { content, ...data } = action.payload;

            if (content) {
                state.aem = JSON.parse(content);
            }
            state.contractDetails = data;
            state.createContractApiStatus = ApiStatus.Fulfilled;
        },
        createContractRejected(state) {
            state.createContractApiStatus = ApiStatus.Rejected;
        },
        acceptContract(state, action: PayloadAction<AcceptContractRequest>) {
            state.acceptContractApiStatus = ApiStatus.Pending;
        },
        acceptContractFulfilled(state, action: PayloadAction<ConsentDetails>) {
            state.consentDetails = action.payload;
            state.acceptContractApiStatus = ApiStatus.Fulfilled;
        },
        acceptContractRejected(state) {
            state.acceptContractApiStatus = ApiStatus.Rejected;
        },
        updateContractEndpoints(state, action: PayloadAction<ContractEndpoints>) {
            state.apiEndpoints= action.payload;
        },
        updateContractApplicationNumber(state, action: PayloadAction<string>) {
            state.applicationNumber= action.payload;
        },
        cancelContract: (state) => state,
    },
});

export const {
    createContract,
    createContractFulfilled,
    createContractRejected,
    acceptContract,
    acceptContractFulfilled,
    acceptContractRejected,
    updateContractEndpoints,
    updateContractApplicationNumber,
    cancelContract,
} = contractSlice.actions;

export const contractsReducer: Reducer<ContractState, AnyAction> = contractSlice.reducer;
